import { render, staticRenderFns } from "./cable.vue?vue&type=template&id=0bc5c5fe&scoped=true"
import script from "./cable.vue?vue&type=script&lang=js"
export * from "./cable.vue?vue&type=script&lang=js"
import style0 from "./cable.vue?vue&type=style&index=0&id=0bc5c5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5c5fe",
  null
  
)

export default component.exports